module.exports = __webpack_public_path__ + "static/cfa-product-f25cf67d49e18c71630c74e0c0f5532f.png";